import { Token, WidgetTable_Cell } from 'emerald-ui';
import { font } from 'emerald-ui/dist/globals/fonts';
import { accent0, gray6, gray7 } from 'emerald-ui/dist/globals/colors';
import styled from 'styled-components';
import { theme } from '../../styles/theme';
import { CargoWidget_DrillIn, CopyLinkIcon } from '../CargoWidgetRow/CargoWidgetRow.style';

export const CargoWidget_ColumnTitle = styled.div`
    font-family: ${font.light};
    color: ${gray7};
    font-size: 1rem;
`;

export const CargoWidget_Root = styled.div`
    /* stylelint-disable */
    ${WidgetTable_Cell}{
        color: ${gray6};
        font-size: 1.25rem;
        ${theme.breakpoints.only('sm')} {
            padding-left: .5em;
            padding-right: .5em;
        }
    }
    ${WidgetTable_Cell}:first-of-type {
        font-family: ${font.medium};
        color: white;
        ${Token} {
            font-size: inherit;
            margin-right: .75em;
            background: ${accent0};
        }
    }
    /* stylelint-enable */

    ${theme.breakpoints.only('xs')} {
        ${WidgetTable_Cell}, ${CargoWidget_ColumnTitle} {
            font-size: .75rem;
        }
        ${CargoWidget_DrillIn} {
            font-size: 1.25rem;
        }
        ${CopyLinkIcon}{
            width: 1.75em;
        }
    }
`;
